<template>
<div>收藏</div>
</template>

<script>
export default {
name: "favorite"
}
</script>

<style scoped>

</style>
